import { FiltersWidget } from '../FiltersWidget';
import { FilterGroup } from '../Tools/FilterGroup';
import { FiltersController } from '../Tools/FiltersController';
declare var PlanManager: any;
declare var Savane: any;
declare var AssetManagerServices: any;

export class LightsFilterWidget extends FilterGroup {

    filterRefreshListener: any | null = null;
    clearCache: boolean = true;
    constructor(container: string) {
        super();
        this.id = 'lights';
        this.name = 'Lumières';
        this.icon = 'far fa-lg fa-lightbulb';
        this.resource = 'assets';
        this.container = container;
        this.controller = new FiltersController();
    }

    static getInstance(): LightsFilterWidget | null {
        if (!FiltersWidget.filterGroups || FiltersWidget.filterGroups.length === 0) return null;
        return FiltersWidget.filterGroups.find((filterGroup: FilterGroup) => filterGroup.id === 'lights') as LightsFilterWidget || null;
    }

    generateStringFilter() {
        var i: number;
        let stringFilters = super.generateStringFilter();
        let filters = FilterGroup.filters;

        if (filters.style !== null && filters.style.length > 0) {
            stringFilters += '&q.styles._id.in=';
            for (i = 0; i < filters.style.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += filters.style[i]._id;
            }
        }

        if (filters.roomType !== null && filters.roomType.length > 0) {
            stringFilters += '&q.environment.roomTypes.in=';
            for (i = 0; i < filters.roomType.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += filters.roomType[i]._id;
            }
        }


        if (Array.isArray(filters.name)) {
            if (filters.name.length > 0) {
                if (FilterGroup.smartSearch()) {
                    stringFilters += '&filter=' + filters.name.join(',');
                }
                else {
                    if (filters.sort && (filters.sort.price > 0 || filters.sort.width > 0)) {
                        stringFilters += '&q.labels.lk=' + filters.name.join(',');
                    }
                    else {
                        stringFilters += '&text=' + filters.name.join(',');
                    }
                }
            }
        }
        else if (filters.name) {
            if (FilterGroup.smartSearch()) {
                stringFilters += '&filter=' + filters.name;
            }
            else {
                if (filters.sort && (filters.sort.price > 0 || filters.sort.width > 0)) {
                    stringFilters += '&q.labels.lk=' + filters.name;
                }
                else {
                    stringFilters += '&text=' + filters.name;
                }
            }
        }

        let result = FilterGroup.initSortArray();
        stringFilters += result.stringFilter;
        let sort: any[] = result.sort;

        if (sort.length > 0) {
            stringFilters += '&sort=' + sort.join(',');
        }

        // We only want non kitchen fab objects
        if (!FiltersWidget.getDecorationService().displayGroups) {
            stringFilters += '&q.pipeline.modelState.eq=validated';
            stringFilters += '&q.pipeline.unrealState.eq=ready';
        }

        if (FilterGroup.filters.assets && FilterGroup.filters.assets.length > 0) {
            stringFilters += '&q._id.in=' + FilterGroup.filters.assets;
        }
        return stringFilters;
    };

    selectionListener: () => void;

    lightsUpdated(): void {
        const lights = FiltersWidget.cacheLights;
        lights.forEach((light, index) => {
            const lightOnId = `lightOn-${index}`;
            const lightOffId = `lightOff-${index}`;
            $(`#${lightOnId}`).prop('checked', light.lightOn);
            $(`#${lightOffId}`).prop('checked', light.lightOff);
            $(`#dropdownMenu-light-${light.id}`).html(LightsFilterWidget.lightTemperatureName(light) + ' <span class="caret"></span>');
        });
    }

    html(): void {
        this.isDestroyed = false;
        this.selectionListener = () => { this.updateTitles(); };
        this.filterRefreshListener = Savane.eventsManager.instance.addListener(Savane.Events.REFRESH_CURRENT_FILTER, () => { this.updateLightsHtml() });
        FilterGroup.addEntitySelectionListener(this.selectionListener);
        let html = this.filtersHtml() + `
        <div>
            ${this.getLightsTableHtml()}
            ${this.getLightsControlsHtml()}
        </div>
        `;
        let container = document.getElementById(this.container);
        if (!container) {
            return;
        }
        container.innerHTML = html;
    }

    getLightsTableHtml(): string {
        return `
        <div class="table-responsive">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="text-align: center;">Objet</th>
                        <th style="text-align: center;">Allumer en jour</th>
                        <th style="text-align: center;">Eteindre en nuit</th>
                        <th style="text-align: center;">Température</th>
                    </tr>
                </thead>
                <tbody id="lights-tbody">
                    ${this.getLightsHtml()}
                </tbody>
            </table>
        </div>
        `;
    }

    static lights() {
        if (FiltersWidget.cacheLights.length === 0) {
            var instance = PlanManager.getInstance();
            if (!instance) {
                return;
            }

            var result = [];
            for (var i = 0; i < instance.scene.floors.length; ++i) {
                result = result.concat(instance.scene.floors[i].arrangementLights);
            }

            FiltersWidget.cacheLights = result;
            return result;
        }
        else {
            return (FiltersWidget.cacheLights);
        }
    };

    static getObjectThumbnailUrl(item) {
        var filename: string, path: string, id: string;
        if (item.isArrangementObjectEntity()) {
            filename = 'preview1-sm.webp';
            path = 'assets';
            id = item.objectId;
        } else if (item.isTechnicalElementEntity()) {
            filename = 'preview1-sm.jpg';
            path = 'technicalelements';
            var component = item.getComponent(Savane.ComponentConstants.ComponentType.TechnicalElementType);
            id = component.technicalElementTypeId;
        }

        return AssetManagerServices.getUrl() + 'api/v1/' + path + '/' + id + '/medias/previews/' + filename;
    };

    static lightTemperatureName(item) {
        switch (item.temperature) {
            case 0:
                return "Normal";
            case 1:
                return "Chaud";
            case 2:
                return "Froid";
            case 3:
                return "Couleur personnalisée";
        }
    }

    updateLightsHtml(): void {
        const tbody = document.getElementById('lights-tbody');
        if (tbody) {
            LightsFilterWidget.lights().forEach((_, index) => {
                this.controller.removeEventListener('click', `light-row-${index}`);
                this.controller.removeEventListener('change', `lightOn-${index}`);
                this.controller.removeEventListener('change', `lightOff-${index}`);
                this.controller.removeEventListener('click', `light0-${index}`, undefined, true);
                this.controller.removeEventListener('click', `light1-${index}`, undefined, true);
                this.controller.removeEventListener('click', `light2-${index}`, undefined, true);
                this.controller.removeEventListener('click', `light3-${index}`, undefined, true);
                this.controller.removeEventListener('click', `deleteLight-${index}`);
            });
            this.clearCache = true;
            tbody.innerHTML = this.getLightsHtml();
        }
    }

    updateTitles() {
        $('.row-title').each((_index, element) => {
            $(element).prop('style', FilterGroup.isItemSelected(parseInt(element.id.split('-')[1])));
        });
    }

    updateCheckboxes(property: 'lightOn' | 'lightOff', value: boolean): void {
        const lights = FiltersWidget.cacheLights;
        lights.forEach((_light, index) => {
            const checkboxId = property === 'lightOn' ? `lightOn-${index}` : `lightOff-${index}`;
            const checkbox = document.getElementById(checkboxId) as HTMLInputElement;
            if (checkbox) {
                checkbox.checked = value;
            }
        });
    }


    getLightsHtml(): string {
        if(this.clearCache){
            FiltersWidget.cacheLights = [];
            this.clearCache = false;
        }
        return LightsFilterWidget.lights().map((light, index) => {
            setTimeout(() => {
                FiltersWidget.initLightColorPicker(light);
                this.controller.addEventListener('click', (ev) => {
                    FilterGroup.selectEntity(light);
                    if (['TR', 'TD', 'IMG', 'SPAN'].includes(ev.target.nodeName)) {
                        this.updateTitles();
                    }
                }, `light-row-${index}`);

                this.controller.addEventListener('change', () => {
                    const value = $(`#lightOn-${index}`).is(":checked");
                    FilterGroup.updateEntityProperty('lightOn', light)(value);
                    $(`#lightOn-${index}`).prop('checked', FilterGroup.updateEntityProperty('lightOn', light)(undefined));
                    this.updateTitles();
                }, `lightOn-${index}`);

                this.controller.addEventListener('change', () => {
                    const value = $(`#lightOff-${index}`).is(":checked");
                    FilterGroup.updateEntityProperty('lightOff', light)(value);
                    $(`#lightOff-${index}`).prop('checked', FilterGroup.updateEntityProperty('lightOff', light)(undefined));
                    this.updateTitles();
                }, `lightOff-${index}`);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('temperature', light, 0)
                    this.updateLightsHtml();
                }, `light0-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('temperature', light, 1);
                    this.updateLightsHtml();
                }, `light1-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('temperature', light, 2);
                    this.updateLightsHtml();
                }, `light2-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('temperature', light, 3)
                    this.updateLightsHtml();
                }, `light3-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.deleteEntity(light);
                    this.updateLightsHtml();
                }, `deleteLight-${index}`);
            }, 50);
            return `
            <tr id="light-row-${index}">
                <td>
                    <span style="float: left;"><img src="${LightsFilterWidget.getObjectThumbnailUrl(light)}" height="40px"></span><span class="row-title" id="light-${light.id}" style="${FilterGroup.isItemSelected(light.id)}">${light.isArrangementObjectEntity() ? light.name : "Element technique spot"}</span>
                </td>
                <td><input type="checkbox" id="lightOn-${index}" ${FilterGroup.updateEntityProperty('lightOn', light)(undefined) ? 'checked' : ''}></td>
                <td><input type="checkbox" id="lightOff-${index}" ${FilterGroup.updateEntityProperty('lightOff', light)(undefined) ? 'checked' : ''}></td>
                <td>
                    <div class="dropdown">
                        <button class="btn btn-default dropdown-toggle" style="padding: 5px !important;" type="button" id="dropdownMenu-light-${light.id}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                            ${LightsFilterWidget.lightTemperatureName(light)}
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu" style="width: auto !important;" aria-labelledby="dropdownMenu-light-${light.id}">
                            <li><a id="light0-${index}">Normal</a></li>
                            <li><a id="light1-${index}">Chaud</a></li>
                            <li><a id="light2-${index}">Froid</a></li>
                            <li><a id="light3-${index}">Couleur personnalisée</a></li>
                        </ul>
                    </div>
                    ${light.temperature === 3 ? `
                    <input class="color-picker-${light.id}">
                    ` : ''}
                </td>
                <td id="deleteLight-${index}" style="cursor: pointer;"><i
                        class="far fa-lg fa-trash-alt"></i>
                </td>
            </tr>
            `;
        }).join('');
    }

    static setDayLightsOn() {
        var instance = PlanManager.getInstance();
        if (!instance) {
            return;
        }

        let lights = FiltersWidget.cacheLights;
        for (let i = 0; i < lights.length; ++i) {
            lights[i].startTemporary();
            lights[i].lightOn = true;
            FiltersWidget.EmitEntityParamEditedEvent(lights[i], "lightOn");
        }
        instance.executeCommand(new Savane.Commands.EditEntitiesCommand(lights));
    }

    static setDayLightsOff() {
        var instance = PlanManager.getInstance();
        if (!instance) {
            return;
        }

        let lights = FiltersWidget.cacheLights;
        for (let i = 0; i < lights.length; ++i) {
            lights[i].startTemporary();
            lights[i].lightOn = false;
            FiltersWidget.EmitEntityParamEditedEvent(lights[i], "lightOn");
        }
        instance.executeCommand(new Savane.Commands.EditEntitiesCommand(lights));
    }

    static setNightLightsOn() {
        var instance = PlanManager.getInstance();
        if (!instance) {
            return;
        }

        let lights = FiltersWidget.cacheLights;
        for (let i = 0; i < lights.length; ++i) {
            lights[i].startTemporary();
            lights[i].lightOff = false;
            FiltersWidget.EmitEntityParamEditedEvent(lights[i], "lightOff");
        }
        instance.executeCommand(new Savane.Commands.EditEntitiesCommand(lights));
    }

    static setNightLightsOff() {
        var instance = PlanManager.getInstance();
        if (!instance) {
            return;
        }

        let lights = FiltersWidget.cacheLights;
        for (let i = 0; i < lights.length; ++i) {
            lights[i].startTemporary();
            lights[i].lightOff = true;
            FiltersWidget.EmitEntityParamEditedEvent(lights[i], "lightOff");
        }
        instance.executeCommand(new Savane.Commands.EditEntitiesCommand(lights));
    }

    getLightsControlsHtml(): string {
        setTimeout(() => {
            this.controller.addEventListener('mousedown', () => {
                LightsFilterWidget.setDayLightsOn();
                this.updateCheckboxes('lightOn', true);
            }, 'Day-LightsOn');

            this.controller.addEventListener('mousedown', () => {
                LightsFilterWidget.setDayLightsOff();
                this.updateCheckboxes('lightOn', false);
            }, 'Day-LightsOff');

            this.controller.addEventListener('mousedown', () => {
                LightsFilterWidget.setNightLightsOn();
                this.updateCheckboxes('lightOff', false);
            }, 'Night-LightsOn');

            this.controller.addEventListener('mousedown', () => {
                LightsFilterWidget.setNightLightsOff();
                this.updateCheckboxes('lightOff', true);
            }, 'Night-LightsOff');
        }, 50);
        return `
        <div>
            <div style="border-top: 1px solid rgb(115, 115, 115);">Rendus de jour</div>
            <button id="Day-LightsOn" class="btn-default" title="Allumer toutes les lumières">
                <i class="far fa-lg fa-lightbulb"></i>
                <span style="margin-left: 10px;">Allumer toutes les lumières</span>
            </button>
            
            <button id="Day-LightsOff" class="btn-default" title="Eteindre toutes les lumières">
                <span class="fa-stack">
                    <i class="far fa-stack-1x fa-lightbulb"></i>
                    <i class="fas fa-ban fa-stack-2x" style="color: tomato;"></i>
                </span>
                <span style="margin-left: 10px;">Eteindre toutes les lumières</span>
            </button>

            <div style="border-top: 1px solid rgb(115, 115, 115);">Rendus de Nuit</div>
            <button id="Night-LightsOn" class="btn-default" title="Allumer toutes les lumières">
                <i class="far fa-lg fa-lightbulb"></i>
                <span style="margin-left: 10px;">Allumer toutes les lumières</span>
            </button>

            <button id="Night-LightsOff" class="btn-default" title="Eteindre toutes les lumières">
                <span class="fa-stack">
                    <i class="far fa-stack-1x fa-lightbulb"></i>
                    <i class="fas fa-ban fa-stack-2x" style="color: tomato;"></i>
                </span>
                <span style="margin-left: 10px;">Eteindre toutes les lumières</span>
            </button>
        </div>
        `;
    }

    destroy(): void {
        super.destroy();
        if (this.selectionListener) {
            FilterGroup.removeEntitySelectionListener(this.selectionListener);
            this.selectionListener = undefined;
        }

        if (this.filterRefreshListener) {
            Savane.eventsManager.instance.removeListener(this.filterRefreshListener);
        }
    }
}